<template>
  <div class="care-login" :class="{ 'care-login--dark': $vuetify.theme.dark }" ref="loginView">
    <header class="care-login__bar"></header>
    <main class="care-login__main">
      <ValidationObserver ref="observer" v-slot="{ passes }" tag="div" class="care-login__form">
        <v-form @submit.prevent="passes(loginSubmit)">
          <v-card elevation="0" flat class="care-login__card">
            <v-card-title class="care-login__title">{{ $t('projectName') }}</v-card-title>
            <v-card-text class="care-login__fields">
              <div class="care-login__line"></div>
              <div class="care-login__row" style="margin-bottom: 30px;">
                <label for="systemType">{{ $t('texts.systemType.label') }}</label>
                <g-select
                  id="systemType"
                  v-model="systemType"
                  :items="systemTypeOptions"
                  item-text="text"
                  item-value="value"
                  outlined
                  hide-details
                  :aria-label="$t('texts.systemType.label')"
                  @input="changeSystemType"
                />
              </div>
              <div class="care-login__row">
                <label for="userId">{{ $t('user.userId') }}</label>
                <ValidationProvider name="user.userId" rules="required" v-slot="{ errors }" tag="div" class="care-login__field">
                  <g-text-field
                    v-model.trim="userId"
                    outlined
                    id="userId"
                    name="userId"
                    autocomplete="off"
                    :tabindex="1"
                    clearable
                    :error-messages="errors"
                    :aria-label="$t('user.userId')"
                    ref="userId"
                  />
                </ValidationProvider>
              </div>
              <div class="care-login__row">
                <label for="userPass">{{ $t('user.userPass') }}</label>
                <ValidationProvider name="user.userPass" rules="required" v-slot="{ errors }" tag="div" class="care-login__field">
                  <g-text-field
                    v-model.trim="userPassword"
                    outlined
                    :type="userPassShow ? 'text' : 'password'"
                    id="userPass"
                    name="userPass"
                    :tabindex="2"
                    :append-icon="userPassShow ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="userPassShow = !userPassShow"
                    autocomplete="new-password"
                    :aria-label="$t('user.userPass')"
                    ref="userPass"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </div>
            </v-card-text>
            <v-card-actions class="care-login__actions">
              <v-btn block height="48" class="care-login__submit" elevation="0" type="submit" :tabindex="3">
                <span class="care-login__icon" aria-hidden="true"></span>
                {{ $t('btns.login') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </ValidationObserver>
    </main>
    <footer class="care-login__footer">COPYRIGHT @GYEYOUNG I&C Co. All right reserved.</footer>
  </div>
</template>

<script>
import { find, sortBy } from 'lodash'
import GTextField from '@/components/form/GTextField.vue'
import GSelect from '@/components/form/GSelect.vue'

export default {
  name: 'loginForm',
  components: {
    GTextField,
    GSelect
  },
  data () {
    return {
      images: {
        // fullLogo: require('@/assets/images/logo/logo_duru_full.svg'),
        fullLogo: require('@/assets/images/mobile/logo-duru-whitemode.svg'),
        loginBtn: require('@/assets/images/login/rectangle.png'),
        idIcons: require('@/assets/images/login/icon-id.png'),
        arrowIcons: require('@/assets/images/login/icon-arrow-r.png')
      },
      spotSeq: null,
      userId: '',
      userPassword: '',
      userPassShow: false,
      systemType: 'apt',
      systemTypeOptions: [
        { value: 'apt', text: this.$t('texts.systemType.apt'), url: process.env.VUE_APP_APT_URL },
        { value: 'care', text: this.$t('texts.systemType.care'), url: process.env.VUE_APP_CARE_URL }
      ]
    }
  },
  watch: {
    //
  },
  mounted () {
    sessionStorage.removeItem('botw_access_info')

    this.$store.state.login.userSeq = null
    this.$store.state.login.userName = ''
    this.$store.state.login.userId = ''
    this.$store.state.login.spotSeq = null
    this.$store.state.login.spotName = null
    this.$store.state.login.loginKey = ''
    this.$store.state.login.encKey = ''
    this.$store.state.login.menuList = []
    this.$store.state.login.userGroupCodeKey = ''
    this.$store.state.login.userSpotList = []

    window.addEventListener('pageshow', this.resetSystemType)
  },
  beforeDestroy () {
    window.removeEventListener('pageshow', this.resetSystemType)
  },
  created () {
    // window.removeEventListener('unload', this.removeCookies)
    // window.addEventListener('unload', this.removeCookies)
  },
  methods: {
    resetSystemType () {
      this.systemType = 'apt'
    },
    changeSystemType (value) {
      const selected = this.systemTypeOptions.find(
        item => item.value === value
      )
      if (selected) {
        window.location.href = selected.url
      }
    },
    loginSubmit: function () {
      console.log('loginSubmit : ', this.userId, this.userPassword)
      const CryptoJS = require('crypto-js')
      const Base64 = require('base-64')
      // 한글로 입력 시 콘솔에러 발생 조치_24.08.26_(unescape(encodeURIComponent(this.userId)))
      const encId = Base64.encode(unescape(encodeURIComponent(this.userId)))
      const cryptOptions = {}
      const iv = window.getHex(this.$store.state.basicEncIv)
      cryptOptions.iv = CryptoJS.enc.Hex.parse(iv)
      const key = window.getHex(this.$store.state.basicEncKey)
      // const encPw = CryptoJS.SHA512(this.userPassword).toString()
      const encPass = CryptoJS.AES.encrypt(this.userPassword, CryptoJS.enc.Hex.parse(key), cryptOptions).toString()

      // const encPw = CryptoJS.SHA512(this.userPassword).toString()
      const data = {
        userId: encId,
        userPass: encPass,
        appFlag: false,
        system: this.systemType
      }
      if (data.userId !== '' && data.userPass !== '') {
        this.$store.dispatch('login', [data, this.loginSubmitCallback])
      }
    },
    loginSubmitCallback: function (response) {
      if (response !== '' && response !== undefined && response.data !== '' && response.data !== undefined) {
        const data = response.data
        if (data !== '' && data !== undefined) {
          const success = data.success
          if (success) {
            const userSeq = data.userSeq
            const userName = data.userName
            const userId = this.userId
            const pwdChangeFlag = data.pwdChangeFlag
            const loginKey = data.loginKey
            const encKey = data.encKey
            let menuList = data.menuList
            const settingFlag = false
            const settingMenuList = []
            const resUserSpotList = data.userSpotList
            const homeNetSpot = data.userHnSpotList !== undefined ? sortBy(data.userHnSpotList, 'spotName') : undefined
            const icfacilitiesSpot = sortBy(data.userSpotList, 'spotName')
            // 계약관리자 메인 contractCompSeq 필요해서 추가
            const compInfo = data.compInfo
            const userGroupCodeKey = data.userGroupCode
            // { userGroupCodeKey: 1, userGroupName: '시스템관리자' },
            // { userGroupCodeKey: 2, userGroupName: '현장승인자_홈넷' },
            // { userGroupCodeKey: 3, userGroupName: '유지보수관리자' },
            // { userGroupCodeKey: 4, userGroupName: '계약관리자' },
            // { userGroupCodeKey: 5, userGroupName: '원격점검자' },
            // //{ userGroupCodeKey: 6, userGroupName: '방문점검자' },
            // { userGroupCodeKey: 7, userGroupName: '현장승인자_정보통신' }
            let userContentCodeId = data.userContentCodeId
            // userGroupCodeKey <= 7 까지는 userContentCodeId값이 null임.
            // userGroupCodeKey >= 8 부터는 userContentCodeId값이 있음.
            // { userContentCodeId: 'CD00002' } -> 계약업체명,
            // { userContentCodeId: 'CD00003' } -> 현장명,
            // { userContentCodeId: 'CD00004' } -> 위탁업체명,
            // // { userContentCodeId: 'CD00001' } -> 방문업체명,
            if (userContentCodeId === undefined) userContentCodeId = null
            let userGubunKey = ''
            const type1Name = this.$t('texts.icFacilities') // 정보통신
            const type2Name = this.$t('texts.homeNet') // 홈네트워크
            const type3Name = this.$t('texts.hnAndIcFac') // 홈네트워크,정보통신
            if (userGroupCodeKey === 1) userGubunKey = type3Name
            if (userGroupCodeKey === 2) userGubunKey = type2Name
            if (userGroupCodeKey === 3) userGubunKey = type1Name
            if (userGroupCodeKey === 4) userGubunKey = type2Name
            if (userGroupCodeKey === 5) userGubunKey = type2Name
            if (userGroupCodeKey === 7) userGubunKey = type1Name
            if (userGroupCodeKey > 7) userGubunKey = homeNetSpot.length > 0 && icfacilitiesSpot.length > 0 ? type3Name : homeNetSpot.length > 0 && icfacilitiesSpot.length === 0 ? type2Name : userContentCodeId === 'CD00002' ? type2Name : type1Name

            // BE 로그인 응답 구조 상 공통적으로 menuList를 응답정보에 보내줘야하는 구조이며 사업부 요청 사항 중 홈넷 현장 메인+check 즉, 권한 + 페이지가 합쳐짐에 따라 menuList는 요청사항 menuList 구조 반영은 fe에서만 빈배열 처리하기로함_2025.06.24
            if ((userGroupCodeKey === 2) || (userGroupCodeKey > 7 && userContentCodeId === 'CD00003')) { // 현장승인자(2), 새로 추가한 그룹명(현장승인자 권한 포함, 8 이상)
              if (userGubunKey.indexOf(type2Name) >= 0 && userGubunKey.indexOf(type1Name) >= 0) {
                const menus = JSON.parse(JSON.stringify(menuList))
                menus.forEach((el, index) => {
                  if (el.menuPath.indexOf('/botw/hn/') >= 0) menuList.splice(index, 1)
                })
              } else if (userGubunKey.indexOf(type2Name) >= 0 && userGubunKey.indexOf(type1Name) < 0) menuList = []
            }

            const groupPermissionList = data.groupPermissionList
            const userGroupName = data.userGroupName
            const userSpotGroupList = []
            if (homeNetSpot !== undefined) {
              userSpotGroupList.push(homeNetSpot)
              userSpotGroupList.push(icfacilitiesSpot)
            } else if (homeNetSpot === undefined) userSpotGroupList.push(resUserSpotList)
            const menuListGroup = []
            let menusList = []
            let reGroupPermissionList = []
            let userSpotList = []

            // dataFlag 반영 추가(with. 메뉴관리)_24.08.07
            for (let i = 0; i < menuList.length; i++) {
              const menu = menuList[i]
              const menuLevel = menu.level
              if (menuLevel === 1 && menu.menuSeq !== 1000000) { // 메인 메뉴목록으로 표출 안되게
                const groupPermission = find(groupPermissionList, { menuSeq: menu.menuSeq }).groupPermission
                if (groupPermission !== undefined) menu.groupPermission = groupPermission
                menu.active = false
                reGroupPermissionList.push(menu)
                if (menu.dataFlag !== null && menu.dataFlag !== undefined && menu.dataFlag) menusList.push(menu)
                if (menu.dataFlag === undefined || menu.dataFlag === null) menusList.push(menu)
              }
            }
            for (let i = 0; i < menusList.length; i++) {
              const menu = menusList[i]
              const menuSeq1 = menu.menuSeq
              const menu2List = []
              for (let j = 0; j < menuList.length; j++) {
                const menu2 = menuList[j]
                if (menu2.level === 2) {
                  menu2.active = false
                  const menuUpper2 = menu2.upperMenuSeq
                  if (menuSeq1 === menuUpper2) {
                    const groupPermission = find(groupPermissionList, { menuSeq: menu2.menuSeq }).groupPermission
                    if (groupPermission !== undefined) menu2.groupPermission = groupPermission
                    reGroupPermissionList.push(menu2)
                    if (menu2.dataFlag !== null && menu2.dataFlag !== undefined && menu2.dataFlag) menu2List.push(menu2)
                    if (menu2.dataFlag === undefined || menu2.dataFlag === null) menu2List.push(menu2)
                  } else {
                    if (menu2List.length > 0) {
                      menu.items = menu2List
                      break
                    }
                  }
                }
              }
              menu.items = menu2List
            }
            for (let i = 0; i < menusList.length; i++) {
              const menu = menusList[i]
              const items = menu.items
              for (let j = 0; j < items.length; j++) {
                const menu2 = items[j]
                const menuSeq2 = menu2.menuSeq
                const menu3List = []
                for (let k = 0; k < menuList.length; k++) {
                  const menu3 = menuList[k]
                  menu3.active = false
                  if (menu3.level === 3 && menu3.menuSeq !== 6040600) { // 운영자설정 > 시스템설정 > 시스템설정 메뉴 표출 X
                    const groupPermission = find(groupPermissionList, { menuSeq: menu3.menuSeq }).groupPermission
                    if (groupPermission !== undefined) menu3.groupPermission = groupPermission
                    const menuUpper2 = menu3.upperMenuSeq
                    if (menuSeq2 === menuUpper2) {
                      reGroupPermissionList.push(menu3)
                      if (menu3.dataFlag !== null && menu3.dataFlag !== undefined && menu3.dataFlag) menu3List.push(menu3)
                      if (menu3.dataFlag === undefined || menu3.dataFlag === null) menu3List.push(menu3)
                    }
                  }
                }
                if (menu3List.length > 0) {
                  menu2.items = menu3List
                }
              }
            }
            console.log('login-menusList1 : ', userGroupCodeKey, JSON.parse(JSON.stringify(menusList)))
            const targetIndex = menusList.findIndex((item) => item.menuSeq === 9000000)
            if (targetIndex > -1) {
              settingMenuList.push(menusList[targetIndex])
              menusList.splice(targetIndex, 1)
              console.log('login-menusList : ', userGroupCodeKey, JSON.parse(JSON.stringify(menusList)))
            }

            // 영역(홈네트워크/정보통신) 별 메뉴
            if (userGroupCodeKey === 1 || (userGroupCodeKey >= 8 && userGubunKey.indexOf(type1Name) >= 0 && userGubunKey.indexOf(type2Name) >= 0 && (userContentCodeId === 'CD00003' || userContentCodeId === 'CD00004'))) {
              this.$store.state.useTypeGubun = true
              this.$store.state.login.gubunGroupCodeKey = '1'
              const homeNetMenu = []
              const icfacilitiesMenu = []
              const homeNetSettingMenu = []
              const icfacilitiesSettingMenu = []

              // 시스템관리자만 추가
              if (userGroupCodeKey === 1) {
                const homeNetItem = {
                  spotSeq: 0,
                  spotName: this.$t('texts.allSelect'),
                  userTypeCode: 1,
                  userTypeName: 'homeNet'
                }
                userSpotGroupList[0].unshift(homeNetItem)
              }
              userSpotList = userSpotGroupList[0]

              const checkCount = (menu) => {
                if (menu.items !== undefined) {
                  if (menu.level === 1) {
                    // 2000000/3000000/4000000/5000000: 사용자 홈네트워크 메뉴
                    if (menu.menuSeq === 2000000 || menu.menuSeq === 3000000 || menu.menuSeq === 4000000 || menu.menuSeq === 5000000) icfacilitiesMenu.push(menu)
                    // 7000000: 사용자 홈네트워크 메뉴
                    if (menu.menuSeq === 7000000) homeNetMenu.push(menu)
                    // 6000000: 운영자 설정
                    if (menu.menuSeq === 6000000) {
                      const preMenu = JSON.parse(JSON.stringify(menu))
                      preMenu.items = []
                      homeNetSettingMenu.push(JSON.parse(JSON.stringify(preMenu)))
                      icfacilitiesSettingMenu.push(JSON.parse(JSON.stringify(preMenu)))
                      menu.items.forEach((menu, index) => {
                        checkCount(menu)
                      })
                    }
                  }
                  if (menu.level === 2) {
                    if (menu.menuSeq === 6060000) {
                      icfacilitiesSettingMenu[0].items.push(menu)
                    }
                    if (menu.menuSeq === 6050000) {
                      homeNetSettingMenu[0].items.push(menu)
                    }
                    if (menu.menuSeq === 6030000 || menu.menuSeq === 6040000) {
                      icfacilitiesSettingMenu[0].items.push(menu)
                      homeNetSettingMenu[0].items.push(menu)
                    }
                  }
                }
              }

              menusList.forEach((menu, index) => {
                checkCount(menu)
              })
              const findMenuIndex = homeNetSettingMenu.findIndex((item) => item.menuSeq === 6000000)
              if (findMenuIndex > -1 && homeNetSettingMenu[findMenuIndex].items.length === 0) homeNetSettingMenu.splice(findMenuIndex, 1)
              homeNetMenu.push(...homeNetSettingMenu)
              icfacilitiesMenu.push(...icfacilitiesSettingMenu)
              menuListGroup.push(homeNetMenu)
              menuListGroup.push(icfacilitiesMenu)
              menusList = menuListGroup[0]
            } else {
              this.$store.state.useTypeGubun = false
              userSpotList = userSpotGroupList[0]
            }
            reGroupPermissionList = JSON.parse(JSON.stringify(reGroupPermissionList))
            reGroupPermissionList.forEach((el, index) => {
              if (el.items !== undefined && el.items.length > 0) delete el.items
            })
            console.log('reGroupPermissionList : ', reGroupPermissionList)

            this.$store.state.login.userSeq = userSeq
            this.$store.state.login.userName = userName
            this.$store.state.login.userId = userId
            this.$store.state.login.pwdChangeFlag = pwdChangeFlag
            this.$store.state.login.loginKey = loginKey
            this.$store.state.login.encKey = encKey
            this.$store.state.login.menuList = JSON.parse(JSON.stringify(menusList))
            this.$store.state.login.userGubunKey = userGubunKey
            this.$store.state.login.userGroupCodeKey = userGroupCodeKey
            this.$store.state.login.userContentCodeId = userContentCodeId
            this.$store.state.login.userGroupName = userGroupName
            this.$store.state.login.userSpotGroupList = userSpotGroupList
            this.$store.state.login.menuListGroup = JSON.parse(JSON.stringify(menuListGroup))

            // 로그인 직후는 첫번째 현정선택
            if (userSpotList.length > 0) {
              this.$store.state.login.spotSeq = userSpotList[0].spotSeq
              this.$store.state.login.spotName = userSpotList[0].spotName
            }

            sessionStorage.setItem('botw_access_info', JSON.stringify({
              userSeq: userSeq,
              userName: userName,
              userId: userId,
              pwdChangeFlag: pwdChangeFlag,
              loginKey: loginKey,
              encKey: encKey,
              compInfo: compInfo,
              settingFlag: settingFlag,
              menuList: menusList,
              settingMenuList: settingMenuList,
              resUserSpotList: resUserSpotList,
              userGubunKey: userGubunKey,
              userGroupCodeKey: userGroupCodeKey,
              userContentCodeId: userContentCodeId,
              spotSeq: this.$store.state.login.spotSeq,
              spotName: this.$store.state.login.spotName,
              groupPermissionList: reGroupPermissionList,
              userGroupName: userGroupName,
              userSpotGroupList: userSpotGroupList,
              menuListGroup: menuListGroup,
              gubunGroupCodeKey: this.$store.state.login.gubunGroupCodeKey,
              useTypeGubun: this.$store.state.useTypeGubun
            }))

            let mainPath = ''
            if (this.$store.state.useTypeGubun && this.$store.state.login.spotSeq === 0) mainPath = '/botw/main/homeNet'
            if (userGroupCodeKey >= 2 && userGroupCodeKey <= 7) {
              if (userGubunKey.indexOf(type1Name) < 0 && userGubunKey.indexOf(type2Name) >= 0 && userGroupCodeKey === 2) mainPath = '/botw/main/homeNet/spot'
              else if (userGubunKey.indexOf(type1Name) < 0 && userGubunKey.indexOf(type2Name) >= 0 && userGroupCodeKey === 4) mainPath = '/botw/main/homeNet/contract'
              else if (userGubunKey.indexOf(type1Name) < 0 && userGubunKey.indexOf(type2Name) >= 0 && userGroupCodeKey === 5) mainPath = '/botw/main/homeNet/remote'
              else mainPath = '/botw/main/icfacilities'
            } else if (userGroupCodeKey >= 8) {
              if (userGubunKey.indexOf(type1Name) < 0 && userGubunKey.indexOf(type2Name) >= 0 && userContentCodeId === 'CD00002') mainPath = '/botw/main/homeNet/contract'
              else if (userGubunKey.indexOf(type1Name) < 0 && userGubunKey.indexOf(type2Name) >= 0 && userContentCodeId === 'CD00003') mainPath = '/botw/main/homeNet/spot'
              else if (userGubunKey.indexOf(type1Name) >= 0 && userGubunKey.indexOf(type2Name) >= 0 && userContentCodeId === 'CD00003') mainPath = '/botw/main/homeNet/spot'
              else mainPath = '/botw/main/icfacilities'
            }
            console.log('mainPath', mainPath, userGubunKey, this.$store.state.login.userGroupCodeKey, this.$store.state.login.gubunGroupCodeKey, this.$store.state.login.spotSeq)
            if (this.$store.state.useTypeGubun) {
              const key = this.$store.state.login.gubunGroupCodeKey
              const seq = this.$store.state.login.spotSeq
              this.$store.state.paramsKey = key
              this.$store.state.paramsSeq = seq
              // this.$router.push({ path: mainPath + `/${key}/${seq}`, params: { key: key, seq: seq } }).catch(() => { })
              this.$router.push({ path: mainPath }).catch(() => { })
            } else if (!this.$store.state.useTypeGubun || this.$store.state.useTypeGubun === null) {
              // this.$router.push({ path: mainPath + '/null/null', params: { key: 'null', seq: 'null' } }).catch(() => {})
              this.$store.state.paramsKey = 'null'
              this.$store.state.paramsSeq = 'null'
              // this.$router.push({ name: mainPath, params: { key: 'null', seq: 'null' } }).catch(() => {})
              this.$router.push({ path: mainPath }).catch(() => {})
            }
          } else {
            console.log('login success fail...')
            // success === false
            const msg = data.failMsg
            setTimeout(() => {
              this.$store.dispatch('snackbarShow', [msg, success])
            }, 150)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.care-login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  background-image: url('~@/assets/img/img_bg.png'), linear-gradient(to right, #3ba8be 0%, #2374c4 100%);
  background-size: cover;
  font-family: Pretendard, sans-serif;
}
.care-login__bar {
  flex: 0 0 60px;
  background-image: linear-gradient(to right, #3ba8be 0%, #2374c4 100%);
}
.care-login__main {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 0px;
}
.care-login__form { width: 460px; max-width: 100%; }
.care-login .care-login__card {
  min-height: 426px;
  padding: 0 40px;
  border-radius: 16px;
  background-color: #fff;
}
.care-login .care-login__title {
  display: block;
  height: 109px;
  padding: 0;
  text-align: center;
  line-height: 109px;
  font-size: 32px;
  font-weight: 600;
  color: #444;
  white-space: nowrap;
}
.care-login .care-login__fields { padding: 0; }
.care-login__line { border-top: 1px solid #cecece; margin-bottom: 40px; }
.care-login__row { display: flex; min-height: 36px; margin: 8px 0; }
.care-login__row > label {
  flex: 0 0 100px;
  line-height: 36px;
  font-size: 14px;
  font-weight: 600;
  color: #888;
}
.care-login__field, .care-login__row > .g-select { flex: 1; min-width: 0; }
.care-login__field >>> .v-text-field__details { margin: 0; }
.care-login__field >>> .v-messages:not(.error--text) { display: none; }
.care-login__field >>> .v-input__append-inner { margin-right: 8px; }
.care-login .care-login__actions { padding: 20px 0 0; }
.care-login .care-login__submit {
  background-color: #2373c4 !important;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: normal;
}
.care-login .care-login__submit:hover { background-color: #1c5c9d !important; }
.care-login .care-login__submit:active { background-color: #164a7e !important; }
.care-login__icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  background: url('~@/assets/icon/icon-24-tline-login.svg') no-repeat center / contain;
}
.care-login__footer {
  flex: 0 0 40px;
  padding: 10px 12px;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.6);
}
.care-login--dark {
  background-image: url('~@/assets/img/g-image.png'), linear-gradient(to right, #22252b 0%, #2c3038 100%);
}
.care-login--dark .care-login__bar { background-image: linear-gradient(to right, #22252b 0%, #2c3038 100%); }
.care-login--dark .care-login__card { background-color: #1a1d21; }
.care-login--dark .care-login__title { color: #d9dee4; }
.care-login--dark .care-login__line { border-top-color: #363d44; }
.care-login--dark .care-login__row > label { color: #7a8188; }
@media (max-width: 600px) {
  .care-login .care-login__card { min-height: 376px; padding: 0 20px 32px; }
  .care-login .care-login__title { height: 104px; line-height: 104px; font-size: clamp(20px, 5vw, 32px); }
  .care-login__line { margin-bottom: 32px; }
  .care-login__row { min-height: 38px; }
  .care-login__row > label { flex-basis: 84px; line-height: 38px; }
  .care-login__field >>> input { font-size: 16px !important; }
  .care-login .care-login__actions { padding-top: 32px; }
}
</style>
